<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import GnbComponent from '@/components/GNB/Index.vue';

import FooterComponent from '@/components/layout/Footer.vue';
import AlertComponent, { alertModalControl } from '@/components/modal/Alert.vue';
import MarketingAgree, { marketingInfo } from './modal/MarketingAgree.vue';

const route = useRoute();
const { isOpenAlertModalCode, propsAlertModalMsg, alertModalClose } = alertModalControl();

const applyPadding = computed(() => {
  const isHomePadding = ['/', '/service'].includes(route.path); // Home,Service 만 패딩기본값(그 외 mt-7/mt-5)
  const isQuickPadding = ['/outbound/quick', '/outbound/app-menu'].includes(route.path); // 퀵 영역값 예외
  const isMassParcelPadding = ['/outbound/mass-parcel', '/outbound/mass-registry'].includes(route.path); // 다량택배 영역값 예외
  const isSignPadding = ['/signin'].includes(route.path); // new 로그인 페이지
  const isCompletePadding = ['/outbound/complete'].includes(route.path); // 주문접수 완료 페이지

  if (isHomePadding) return 'isHomePadding';
  if (isQuickPadding) return 'isQuickPadding';
  if (isMassParcelPadding || isCompletePadding) return 'isMassParcelPadding';
  if (isSignPadding) return 'isSignPadding';
  return 'isDefaultPadding';
});

const { isMarketingRender } = marketingInfo();
</script>

<template>
  <!-- global Modal -->
  <alert-component
    v-if="isOpenAlertModalCode"
    :code="isOpenAlertModalCode"
    :message="propsAlertModalMsg"
    @close="alertModalClose"
  />
  <marketing-agree v-if="isMarketingRender"></marketing-agree>

  <!-- Layout -->
  <gnb-component />

  <main
    class="min-h-screen"
    :class="{
      'desktop:-mt-[81px] mobile:-mt-[51px] desktop:mb-20 mobile:mb-[30px]': applyPadding === 'isHomePadding',
      'desktop:pt-7 mobile:pt-5 desktop:pb-20 mobile:pb-[30px] bg-black0': applyPadding === 'isQuickPadding',
      'desktop:mt-7 mobile:mt-5 desktop:mb-20 mobile:mb-[30px]': applyPadding === 'isDefaultPadding',
      'desktop:mt-[-28px] mobile:mt-[-28px] bg-black0': applyPadding === 'isMassParcelPadding',
      'mb-[-8px]': applyPadding === 'isSignPadding',
    }"
  >
    <router-view />
  </main>

  <footer-component />
</template>

<style lang="scss"></style>
